import { io } from "socket.io-client";
import ws_config from "../config/ws.config";
import peer_config from "../config/peerjs.config";
import * as React from "react";
import Typography from "@mui/material/Typography";
import { Peer } from "peerjs";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import LoaderWithStatus from "./LoaderWithStatus"; 
import CallIcon from '@mui/icons-material/Call';
import { useNavigate, useParams } from "react-router-dom";
import Paper from "@mui/material/Paper";
import BottomNavigation from "@mui/material/BottomNavigation";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";
import FlipCameraAndroidOutlinedIcon from "@mui/icons-material/FlipCameraAndroidOutlined";
import VideocamOffOutlinedIcon from "@mui/icons-material/VideocamOffOutlined";
import MicOffOutlinedIcon from "@mui/icons-material/MicOffOutlined";
import Box from "@mui/material/Box";
import { makeStyles } from '@mui/styles';
import { useMediaQuery } from '@mui/material';
import { padding } from "@mui/system";
import Divider from '@mui/material/Divider';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';
import PhoneDisabledIcon from '@mui/icons-material/PhoneDisabled';
import CheckCameraWidget from './CheckCameraWidget';
import CheckSocetPage from './CheckSocetPage';
import CheckPeerPage from './CheckPeerPage';
import VideoWaitConnectPage from './VideoWaitConnectPage';
import videoChatState from "./VideoWaitConnectPageStates";


/// peer and socet io init
//const peer = new Peer(peer_config); /// инициализация подключения PEER JS -- TEST
//const socket = io(ws_config.ws_server, ws_config.conf); /// инициализация ws ТЕСТ

let peer = null;
let socket = null;

const localVideoref = React.createRef();   /// локальное видео 
const remontVideoref = React.createRef();  /// удаленное видео



export default function VideoCall() {

  /// Получаю GET параметры
  const { call_guid } = useParams(); //console.log("call_guid", getJsonFromBase64(call_guid).guid);
  const [roomId, setRoomId] = React.useState(
    //getJsonFromBase64(call_guid).guid
    call_guid
  );


  /*/// ws
  const [isConnectedWs, setIsConnectedWs] = React.useState(socket.connected); // подключено в ws
  const [isConnectedWs, setIsConnectedWs] = React.useState(null);
  const [user_id, setUserId] = React.useState(null);
  const [room_info, setroom_info] = React.useState([]);
  const [wsError, setWsError] = React.useState("");*/


  /// ws v2
  const wsInitialState = {
    conected: false, 
    err: null,
    user_id: null, 
    room_info: []
  }
  const [wsObject, setWsObject] = React.useState(wsInitialState);

  const [wsIncomingMsg, setWsIncomingMsg] = React.useState(null);



    /// peerjs v2
    const peerInitialState = {
      conectedToServer: false, 
      conectedWithOtherPeerUser: false,
      err: null,
      user_id: null, 
      remote_peer_id: null
    }
    const [peerObject, setPeerObject] = React.useState(peerInitialState);

    //console.log('peerObjectddddd', peerObject);
/*
  // pear js
  const [isConnectedPear, setIsConnectedPear] = React.useState(false);
  const [peerError, setPeerError] = React.useState("");
  const [peerUserId, setPeerUserId] = React.useState(null);
  const [remote_peer_id, setremote_peer_id] = React.useState(null);
  const [peerjs_connectionState, set_peerjs_connectionState] = React.useState(null);
  const peerUserRef = React.useRef({});
  const localMediaStramRef = React.useRef({});

  */
 

  /// устройства
  const [local_video, setlocal_video] = React.useState({
    enabled: false, 
    err_text: ''
  }); /// видео


  const localStream = React.useRef({});


  //const [msg, setmsg] = React.useState("");
  const [msgOnTop, setMsgOnTop] = React.useState("");


   /** 
   * Общий алгоритм 
   *  2 экрана. Мой и удаленного пользователя
   *  У меня есть следующие статусы: 
   *    1. Статус камеры и микрофона 
   *    2. Статус сосединения с ws 
   *    3. Статус соединения по peer js 
   *    4. Статусы webRTS
   * 
   * **/
  
   const UiStatesList = {
    CheckCameraMic: 'CheckCameraMic',
    CheckWs: 'CheckWs',
    CheckPeer: 'CheckPeer',
    ShowCameraFullScree: 'ShowCameraFullScree',
    ShowVideoChat: 'ShowVideoChat'
  };

  const [uiState, setUiState] = React.useState(UiStatesList.CheckCameraMic);

  const [videoChatPageState, setVideoChatPageState] = React.useState(videoChatState.WaitingMember);

  

  /// ловим изменения в состоянии UI. В зависимости от состояние запускаем что либо
  React.useEffect(() => {
      console.log("Состояние ui", uiState);

      /// если состояние поменялось на страницы сокетов, то инициализирую сокеты
      if(uiState === UiStatesList.CheckWs){        
        initSocet2();        
      }

      if(uiState === UiStatesList.CheckPeer){        
        initPear2();     
      }   

      if(uiState === UiStatesList.ShowCameraFullScree){    


       

        getMediaStream().then(()=>{
          ///если на этой страница то подключаю к комнате    
          socketSendAction('join_room', {
            roomId: roomId,
            spd_info: null,
          });
        });
        
      }  

  }, [uiState ]);



  /// Наблюдаем за статусом videoChatPageState
  React.useEffect(() => {
    console.log("Состояние ui videoChatPageState", videoChatPageState);

    /// если состояние MemberConected то есть все пользователи подключены

      if(videoChatPageState === videoChatState.MemberConected){         
          
          const io_reciver = wsObject.room_info[0].userId;  // другой пользователь 
          const myPeerId = peerObject.user_id; 
          
          // отправка моего пира 
          sendMyPearId2(io_reciver, myPeerId);

          // изменить статус как обмен пирами 
          setVideoChatPageState(videoChatState.PeerExchange);
      }

      
      /// если состояние поменялось на установка звонка videoChatState.EstablishingConnection
      if(videoChatPageState === videoChatState.EstablishingConnection && stream!=null){
          callToUser();
      }

      if(videoChatPageState === videoChatState.CallEnd){
        alert('Звонок завершен')
      }

    

}, [videoChatPageState]);

  



React.useEffect(() => {
 // console.log("Следить за входящими",);

    /// если состояние поменялось на страницы сокетов, то инициализирую сокеты
    if(wsIncomingMsg!==null){
      onIncomingMessages(wsIncomingMsg);
    }
   

}, [wsIncomingMsg ]);




const [stream, setStream] = React.useState(null);
const [streamRemote, setStreamRemote] = React.useState(null);

const getMediaStream = async () => {
  try {

    console.log('run ------------------ > getMediaStream')
    const stream = await navigator.mediaDevices.getUserMedia({ video: true, audio: true });

    const clonedStream = stream.clone();

    stream.getAudioTracks()[0].enabled = false;
    // Установка видеопотока в элемент <video>
    setStream(stream);

    console.log('localStream _1', localStream);
    // короче в кэлбэках peer js не виден контекст state - ов.  по этому делаю копию стрима      
    localStream.current['MediaStream'] = clonedStream;

    
    console.log('localStream _2', localStream);
    
  } catch (error) {
    console.log('Ошибка при получении доступа к камере/микрофону:', error);
    setStream(null)
    alert('Ошибка при получении доступа к камере/микрофону: ' + error);
  }
};

  /*function getCameraStream(){
    navigator.mediaDevices
    .getUserMedia({ video: true, audio: true })
    .then((stream) => {
      // Установка видеопотока в элемент <video>
      setStream(stream);
      
    })
    .catch((error) => {
      console.log('Ошибка при получении доступа к камере/микрофону:', error);
      alert('Ошибка при получении доступа к камере/микрофону: ' + error);
    });
  }*/


    function socketSendAction(action, data){
      socket.emit(action, data);   
    }
  

   //// установка соединеия с сигнальным сервером
   async function initSocet2() {
    try {
      console.log("run==> initSocet2");

      socket = io(ws_config.ws_server, ws_config.conf);

      // встроенные события
      socket.on("connect", ()=>{socetHandler('connect', null)});
      socket.on("disconnect", ()=>{socetHandler('disconnect', null)});
      socket.on("connect_error", (error)=>{socetHandler('connect_error', error)});

      // кастомные
      socket.on("join_room", (value)=>{socetHandler('join_room', value)});                // зашел в комнату
      socket.on("update_room_info", (value)=>{socetHandler('update_room_info', value)}); // зашли еще пользователи
      socket.on("incoming_messages", (value)=>{socetHandler('incoming_messages', value)}); /// принимает входяшие соединения

      return () => {
        socket.off("connect", ()=>{socetHandler('connect', null)});
        socket.off("disconnect", ()=>{socetHandler('disconnect', null)});
        socket.off("connect_error", (error)=>{socetHandler('connect_error', error)});
        socket.off("join_room", (value)=>{socetHandler('join_room', value)});                
        socket.off("update_room_info", (value)=>{socetHandler('update_room_info', value)});  
        socket.off("incoming_messages", (value)=>{socetHandler('incoming_messages', value)});  
  
      };
    } catch (e) {
      console.error(e);

      setWsObject((prevState) => ({
        ...prevState,
        conected : false, 
        err: 'Ошибка инициализации' + e, 
        user_id: null,  
        room_info: []        
      }));

    }
  }



  
  function initPear2() {
    try {
      console.log("run===> initPear2");

      peer = new Peer(peer_config); /// инициализация

      peer.on("open", (id) => {  /// соединение установлено
        peerHandller2("open", id);
      });
      peer.on("connection", (dataConnection) => {  /// событие сработает тогда когда вызову peer.connect() если соединение успешно установлено
        peerHandller2("connection", dataConnection);
      });
      peer.on('call', (mediaConnection) => {
        peerHandller2('call', mediaConnection);
      }); /// событие звонка. На него надо ответить answer
      peer.on("close", (mediaConnection) => {
        peerHandller2("close", mediaConnection);
      });
      peer.on("disconnected", () => {
        peerHandller2("disconnected", null);
      });
      peer.on("error", (err) => {
        peerHandller2("error", err);
      });

      peer.on("connectionStateChange", (state) => {
        peerHandller2("connectionStateChange", state);
      });

    

      return () => {
        peer.off("open", (id) => {
          peerHandller2("open", id);
        });
        peer.off("connection", (dataConnection) => {
          peerHandller2("connection", dataConnection);
        });
        peer.off("call", (mediaConnection) => {
          peerHandller2("call", mediaConnection);
        }); /// событие звонка. На него надо ответить answer
        peer.off("close", (mediaConnection) => {
          peerHandller2("close", mediaConnection);
        });
        peer.off("disconnected", () => {
          peerHandller2("disconnected", null);
        });
        peer.off("error", (err) => {
          peerHandller2("error", err);
        });

        peer.off("connectionStateChange", (state) => {
          peerHandller2("connectionStateChange", state);
        });
      };
    } catch (e) {
      console.error(e);
    }
  }

  

  const isXs = useMediaQuery('(max-width:600px)');
  const isSm = useMediaQuery('(min-width:600px) and (max-width:960px)');
  const isMd = useMediaQuery('(min-width:960px) and (max-width:1280px)');
  const isLg = useMediaQuery('(min-width:1280px)');







/*
  // OnInit
  React.useEffect(() => {
    console.log("on init");
    //initData();

    //initSocet();
    //initPear();
   // enableLocalVideo();
  }, []);*/


/*
  React.useEffect(() => {
    if (remote_peer_id !== null) {
      console.log("remote_peer_id пришел", remote_peer_id);

      callToUser();
    }
  }, [remote_peer_id]);*/


/*
  React.useEffect(() => {
    console.log("ПРоверяю надо ли звонить ");
    //initData();

    if (isConnectedWs && isConnectedPear && local_video.enabled) {
      //sendMyPearId(e.userId)
      /// отправить пир ид
      room_info.forEach((e) => {
        if (e.userId != user_id) {
          console.log("ЗВОНЮ");
          sendMyPearId(e.userId);
        }
      });
    }
  }, [isConnectedWs, isConnectedPear, local_video]);*/



  function getJsonFromBase64(base64String) {
    const decoder = new TextDecoder();
    const decodedData = atob(base64String);
    const decodedString = decoder.decode(
      new Uint8Array([...decodedData].map((char) => char.charCodeAt(0)))
    );

    const jsonObject = JSON.parse(decodedString);
    // console.log('getJsonFromBase64', jsonObject);
    return jsonObject;
  }

/*
  /// инициализация peer js
  function initPear() {
    try {
      console.log("run===> initPear");

      peer.on("open", (id) => {
        peerHandller("open", id);
      });
      peer.on("connection", (dataConnection) => {
        peerHandller("connection", dataConnection);
      });
      peer.on("call", (mediaConnection) => {
        peerHandller("call", mediaConnection);
      }); /// событие звонка. На него надо ответить answer
      peer.on("close", (mediaConnection) => {
        peerHandller("close", mediaConnection);
      });
      peer.on("disconnected", () => {
        peerHandller("disconnected", null);
      });
      peer.on("error", (err) => {
        peerHandller("error", err);
      });

      return () => {
        peer.off("open", (id) => {
          peerHandller("open", id);
        });
        peer.off("connection", (dataConnection) => {
          peerHandller("connection", dataConnection);
        });
        peer.off("call", (mediaConnection) => {
          peerHandller("call", mediaConnection);
        }); /// событие звонка. На него надо ответить answer
        peer.off("close", (mediaConnection) => {
          peerHandller("close", mediaConnection);
        });
        peer.off("disconnected", () => {
          peerHandller("disconnected", null);
        });
        peer.off("error", (err) => {
          peerHandller("error", err);
        });
      };
    } catch (e) {
      console.error(e);
    }
  }*/




/*
  /// Отловить события от Peer js
  function peerHandller(action, payload) {
    console.log("peerHandller ==> ", action);
    console.log("peerHandller ==> ", payload);

    if (action === "open") {
      setIsConnectedPear(true);
      setPeerUserId(payload);
      setmsg('Подключение к пиру установлено');
      peerUserRef.current["PeerUserId"] = payload;
    }

    if (action === "error") {
      setIsConnectedPear(false);
      setPeerError(payload.toString());
      setmsg('Ошибка подключения к пиру' + payload.toString());
    }

    if (action === "close") {
      setIsConnectedPear(false);
      setmsg('Соединение закрыто. peer closed.' );
      alert("Соединение закрыто. peer closed.");
    }

    if (action === "disconnected") {
      setIsConnectedPear(false);
      setmsg('Соединение потеряно' );
      alert("Соединение потеряно");
    }

    if (action === "call") {
      /// событие когда кто то меня вызывает
      console.log("кто то мне звонит");
      setmsg('Звонок');
      /// ответом на звонок я отпрвлю ему свой поток
      payload.answer(localMediaStramRef.current.MediaStream);

      /// сработает когда удаленный чувак отправит поток с камеры
      payload.on("stream", (userVideoStream) => {
        remontVideoref.current.srcObject = userVideoStream;
      });
    }
  }
*/


  

  /*//// установка соединеия с сигнальным сервером
  async function initSocet() {
    try {
      console.log("run==> initSocet");

      // встроенные события
      socket.on("connect", onConnectWs);
      socket.on("disconnect", onDisconnectWs);
      socket.on("connect_error", onConnectWsError);

      // кастомные
      socket.on("join_room", onJoinRoom); // зашел в комнату
      socket.on("update_room_info", onUpdateRoomInfo); // зашли еще пользователи
      socket.on("incoming_messages", onIncomingMessages); /// принимает входяшие соединения

      return () => {
        socket.off("connect", onConnectWs);
        socket.off("disconnect", onDisconnectWs);
        socket.off("join_room", onJoinRoom);
        socket.off("update_room_info", onUpdateRoomInfo);
        socket.off("incoming_messages", onIncomingMessages);
        socket.off("connect_error", onConnectWsError);
      };
    } catch (e) {
      console.error(e);
    }
  }*/


 


  /// Обработка сообщений от socet io
  function socetHandler(action, payload){
    console.log("socetHandler run");
    console.log("socetHandler ==> ", action);
    console.log("socetHandler ==> ", payload);

      if(action==='connect'){        
          setWsObject((prevState) => ({
            ...prevState,
            conected : true, 
            err:null, 
            user_id: socket.id,          
          }));
      }

      if(action==='disconnect'){
          setWsObject((prevState) => ({
            ...prevState,
            conected : false, 
            err: 'Ошибка подключения к сигнальному серверу', 
            user_id: null,  
            room_info: []        
          }));
      } 

      if(action==='connect_error'){
        setWsObject((prevState) => ({
          ...prevState,
          conected : false, 
          err: 'Ошибка соединения' + payload, 
          user_id: null,  
          room_info: []        
        }));
      } 

      if(action==='join_room'){ 
          // не используется
      } 

      if(action==='update_room_info'){ // кто зашел в комнату и пришла инфа о тех кто в комнате
         
          const newList = payload.filter((e)=> e.userId !== socket.id); 
          
          setWsObject((prevState) => ({
            ...prevState, 
            room_info: newList        
          }));

          

          /// если пользователей 1 то говорю что все подключены
          if(newList.length ===1){
            setVideoChatPageState(videoChatState.MemberConected);                         
          }

          /// ожидание пользователя
          if(newList.length ===0){
            setVideoChatPageState(videoChatState.WaitingMember)
          }

          /// если большо одно что то пошло не так 
          if(newList.length > 1){
            setVideoChatPageState(videoChatState.Error)
          }
          

          //console.log('newList', newList.length);
      }


      if(action==='incoming_messages'){ /// ловим вхоядище сообщения по сокету

          //const from = payload.from; 
          //const dataPayload = payload.payload; 
          //const action_incoming = payload.action; 
          setWsIncomingMsg(payload);
      } 
  }


  /// обработка входящих
  async function onIncomingMessages(payload){
        console.log('Обработка вхоядщихfffff', payload);

         const from = payload.from; 
         const dataPayload = payload.payload; 
         const action_incoming = payload.action; 

        /// если пришел пиир от друго пользователя
        if(action_incoming === 'remote_peer_id'){
          const _remote_peer_id = dataPayload[0].remote_peer_id;
          if(_remote_peer_id!==peerObject.remote_peer_id){

            /// сохроняю удаленный пир если такого нету 
            setPeerObject((prevState) => ({
              ...prevState,
                remote_peer_id : _remote_peer_id 
            }));

            /// в ответ отправляю свой пиир 
            sendMsgWs(from, 'anser_remote_peer_id', [{anser_remote_peer_id: peerObject.user_id}]);
          }
          
        }

        /// если это значит я уже отправил свой пир и он мне отвечает своим
        if(action_incoming === 'anser_remote_peer_id'){

          const anser_remote_peer_id = dataPayload[0].anser_remote_peer_id;
          if(anser_remote_peer_id!==peerObject.remote_peer_id){

            /// сохроняю удаленный пир если такого нету 
            setPeerObject((prevState) => ({
              ...prevState,
                remote_peer_id : anser_remote_peer_id 
            }));

              
            
          }

          if(peerObject.remote_peer_id!==null && videoChatPageState!==videoChatState.EstablishingConnection){ /// если пришел пиир от удаленного пользователя значит можно начать конект. Меняю статус ui 
            setVideoChatPageState(videoChatState.EstablishingConnection);   
          }
           
           
        }

        if(action_incoming === 'call_end'){
          closePeerConnect2();
        }


  }

  /// кэлбэки для peerjs
  function peerHandller2(action, payload) {
    console.log("---------------peerHandller2");
    console.log("peerHandller2 ==> ", action);
    console.log("peerHandller2 ==> ", payload);

    if (action === "open") { /// установлено соединение с сервером peerjs
        setPeerObject((prevState) => ({
          ...prevState,
          conectedToServer : true, 
          err:null, 
          user_id: payload,    /// сюда придет peer id. Он нужен для установки связи с другим пиром. Но при этом что бы передать этот пир нужен сигнальный сервер      
        }));

       
    }

    if (action === "error") {
      setPeerObject((prevState) => ({
        ...prevState,
        conectedToServer : false, 
        err: 'Ошибка соединения с сервером' + payload, 
        user_id: null,    /// сюда придет peer id. Он нужен для установки связи с другим пиром. Но при этом что бы передать этот пир нужен сигнальный сервер      
      }));

      setVideoChatPageState(videoChatState.Error);
    }

    if (action === "close") {
      setPeerObject((prevState) => ({
        ...prevState,
        conectedToServer : false, 
        err: 'все соединения закрыты.', 
        user_id: null,    /// сюда придет peer id. Он нужен для установки связи с другим пиром. Но при этом что бы передать этот пир нужен сигнальный сервер      
      }));

      setVideoChatPageState(videoChatState.LostConect);
    }

    if (action === "disconnected") {
      setPeerObject((prevState) => ({
        ...prevState,
        conectedToServer : false, 
        err: 'disconnected', 
        user_id: null,    /// сюда придет peer id. Он нужен для установки связи с другим пиром. Но при этом что бы передать этот пир нужен сигнальный сервер      
      }));

      setVideoChatPageState(videoChatState.LostConect);
    }

    if (action === "connectionStateChange") {
      console.log('state dddd', payload);
    }
    

    if (action === 'call') {
        console.log('кто то мне звонит', ); 

         /// ответом на звонок я отпрвлю ему свой поток
         //payload.answer(stream);
         console.log('отвечаю на звонок своим стримом', localStream.current.MediaStream)
         payload.answer(localStream.current.MediaStream)
        

         /// сработает когда удаленный чувак отправит поток с камеры
         payload.on("stream", (userVideoStream) => {
            console.log('в кал пришло')
           //remontVideoref.current.srcObject = userVideoStream;
           setStreamRemote(userVideoStream)
         });

         payload.on('close', () => {
          // Обработка закрытия вызова
          setVideoChatPageState(videoChatState.CallEnd);
        });

        payload.on('error', (error) => {
          // Обработка ошибки вызова
          setVideoChatPageState(videoChatState.Error);
        });
    }
  }



/*
  // подключено ws
  function onConnectWs() {
    console.log("run===> onConnectWs");

    /// простоавить признак покдлючения к ws
    setIsConnectedWs(socket.connected);

    /// id клиента
    setUserId(socket.id);

    setmsg('Соединение к сокету установлено' );

    // когда соединение по сокетам установлено, отправляю событие добавления в комнату
    socket.emit("join_room", {
      roomId: roomId,
      spd_info: null,
    });
  }
*/

/*
  // отключено ws
  function onDisconnectWs() {
    setIsConnectedWs(false);
    setIsConnectedPear(false);
    setmsg('Соединение с сокетом потеряно' );
    alert("Соединение потеряно");
  }
*/
/*
  function onConnectWsError(error) {
    setIsConnectedWs(false);
    setmsg('Ошибка подключения к сигнальному серверу' );
    setWsError("Ошибка подключения к сигнальному серверу");
    console.log("Ошибка подключения к ws", error);
  }
*/

/*
  // событие подключения к компнте самого пользователя
  function onJoinRoom(value) {
    console.log("onJoinRoom", value);

    //setroom_info(value);
  }
*/


  /*/// когда подключился кто то новый
  function onUpdateRoomInfo(value) {
    console.log("onUpdateRoomInfo", value);

    // исключить себя из списка
    const newList = value.filter((e) => e.userId !== socket.id);
    //console.log('newList' , user_id)

    if(newList.length>1){
      setmsg('Подключился новый пользователь' );
    }

    setroom_info(newList);
  }*/


  /*/// все входящие событя от сокета
  async function onIncomingMessages(value) {
    console.log("onIncomingMessages", value.action);
    console.log("onIncomingMessages", value);

    const {
      from, // от кого пришло
      to, // кому пришло, должен быть равен с user_id
      payload, // данные которые пришли
      action, // событие
    } = value;

    /// если пришел пиир от друго пользователя
    if (action === "remote_peer_id") {
      /// сохраняю его пиир
      setremote_peer_id(payload[0].remote_peer_id);
      sendMsgWs(from, "anser_remote_peer_id", [
        { anser_remote_peer_id: peerUserRef.current.PeerUserId },
      ]);

      /// отправляю свой пир ид в качестве ответа
     // socket.emit("send_to_user", {     
       // receiver_id: from,
        //action: 'anser_remote_peer_id',
        //payload: [
         // {        
          //  anser_remote_peer_id: peerUserId
          //}
        //]                                                          
      //});

    }

    /// если это значит я уже отправил свой пир и он мне отвечает своим
    if (action === "anser_remote_peer_id") {
      // сохраняю его пир как удаленный
      setremote_peer_id(payload[0].anser_remote_peer_id);
    }
  }*/


  /// отправить мой пирид пользователю через веб сокеты
 /* function sendMyPearId(receiver_id) {
    socket.emit("send_to_user", {
      receiver_id: receiver_id,
      action: "remote_peer_id",
      payload: [
        {
          remote_peer_id: peerUserId,
        },
      ],
    });
  }*/

  function sendMyPearId2(receiver_id, myPeerId) {
    console.log('sendMyPearId2', myPeerId)
    socket.emit("send_to_user", {
      receiver_id: receiver_id,
      action: "remote_peer_id",
      payload: [
        {
          remote_peer_id: myPeerId,
        },
      ],
    });
  }



  function sendMsgWs(to, action, data) {
    console.log('run === > sendMsgWs' , data);
    //console.log('run === > sendAnswer' , peerUserRef.current.PeerUserId);
    socket.emit("send_to_user", {
      receiver_id: to,
      action: action,
      payload: data, //[{anser_remote_peer_id: peerUserRef.current.PeerUserId}]
    });
  }

 
 /* //// Включить камеру и видео
  async function enableLocalVideo() {
    try {
      let stream = await navigator.mediaDevices.getUserMedia({
        video: true,
        audio: true,
      });


      /// сохранить элемент
      //setMediaStream(stream);
      localMediaStramRef.current["MediaStream"] = stream;

      /// установить поток в свой плеер
      localVideoref.current.srcObject = stream;
      setlocal_video({
        enabled: true, 
        err_text: ''
      });

      //return true;
    } catch (e) {
      //setlocal_video_audio_enable(false);
      console.error(e);

      setlocal_video({
        enabled: false, 
        err_text: 'Включите камеру/микрофон'
      });

      //alert("Не удалось получить доступ к камере/микрофону");
      //return false;
    }
  }
*/

  /// подключение к пользователю
  async function callToUser()  {
    console.log("I call to", peerObject.remote_peer_id);
    //console.log("peer", peer);
    //let stream = null; 
    

    
    const call = peer.call(
      peerObject.remote_peer_id,
      stream//localStream.current.MediaStream
    );

    
    /// сработает тогда когда пришел видео потом от пользователя setVideoChatPageState(videoChatState.PeerExchange);
    call.on('stream', (remoteStream) => {
      console.log('callToUser', remoteStream)
      //remontVideoref.current.srcObject = remoteStream;
      setStreamRemote(remoteStream);
      setVideoChatPageState(videoChatState.Conected);
    });

    call.on("close", function () {
      console.log("Медиа-соединение закрыто");
      
      // Выполните здесь необходимые действия при закрытии соединения
      //alert("Медиа-соединение закрыто");
      setVideoChatPageState(videoChatState.CallEnd);
    });

    call.on("error", function (error) {
      
      console.error("Произошла ошибка в медиа-соединении:", error);
      //alert("Произошла ошибка в медиа-соединении");
      setVideoChatPageState(videoChatState.Error);
      // Выполните здесь необходимые действия при ошибке
    });

    // Отслеживание состояния соединения ICE
    call.peerConnection.addEventListener('iceconnectionstatechange', function(event) {
      var iceConnectionState = call.peerConnection.iceConnectionState;
      /*if (iceConnectionState === 'disconnected') {
        console.log('Состояние iceConnectionState изменилось на disconnected');
        // Выполните здесь необходимые действия при отключении соединения
      }*/
      handleIceConnectionState(iceConnectionState);
    });

    // Отслеживание изменений состояния соединения ICE
    call.on('iceConnectionStateChange', () => {
   
      console.log('Соединение ICE было отключено', call.iceConnectionState);
    });

    console.log('ICE', call.iceConnectionState)


    /*call.peerConnection.addEventListener(
      "iceconnectionstatechange",
      function (event) {
        var iceConnectionState = call.peerConnection.iceConnectionState;
     
        handleIceConnectionState(iceConnectionState);
      }
    );*/
  }


  /// отловить состояние соединения webRtc
  function handleIceConnectionState(iceConnectionState) {
    console.log("Состояние соединения", iceConnectionState);
    if(iceConnectionState==='disconnected'){
      setVideoChatPageState(videoChatState.CallEnd);
    }
  }


  /*/// Кнопка подключится
  async function doCall() {
    try {
     

      if (local_video.enabled === false) {
        alert("Включите видео/аудио");
        return;
      }

      if (isConnectedPear === false) {
        alert("Нету peer соединения ");
        return;
      }

      if (room_info.length < 1) {
        console.log("room_info.length", room_info.length);
        alert("Конферения пуста");
        return;
      }

      if (room_info.length > 1) {
        alert("Не правильное количество людей в комнате ");
        return;
      }

      //sendMyPearId(e.userId)
      /// отправить пир ид
      room_info.forEach((e) => {
        if (e.userId != user_id) {
          sendMyPearId(e.userId);
        }
      });
    } catch (e) {
      console.error(e);
      alert("Не удалось установить соединение");
    }
  }*/

/*
  function renderPeerJsConectionState(state) {
    console.log("renderPeerJsConectionState", state);
    if (state === "new") {
      return (
        <>
          <Grid spacing={2} container direction="row">
            <Grid item sx={{ color: "gray" }}>
              id
            </Grid>
            <Grid item>
              <Typography sx={{ fontSize: "15px", color: "gray" }}>
                {state}
              </Typography>{" "}
            </Grid>
          </Grid>
        </>
      );
    } else if (state === "checking") {
      return (
        <Typography sx={{ fontSize: "15px", color: "gray" }}>
          проверка доступности
        </Typography>
      );
    } else if (state === "connected") {
      return (
        <Typography sx={{ fontSize: "15px", color: "gray" }}>
          Установлено успешное соединение
        </Typography>
      );
    } else if (state === "completed") {
      return (
        <Typography sx={{ fontSize: "15px", color: "gray" }}>
          соединение полностью установлено и проверено
        </Typography>
      );
    } else if (state === "failed") {
      return (
        <Typography sx={{ fontSize: "15px", color: "gray" }}>
          При установке соединения произошла ошибка или не удалось установить
          связь между пирами. Нет возможности передачи данных.
        </Typography>
      );
    } else if (state === "disconnected") {
      return (
        <Typography sx={{ fontSize: "15px", color: "red" }}>
          Ранее установленное соединение было потеряно. Обычно, это происходит
          при временных проблемах соединения или потере связи. Обновите страницу
          и попробуйте заново
        </Typography>
      );
    } else if (state === "closed") {
      return (
        <Typography sx={{ fontSize: "15px", color: "gray" }}>
          Соединение было закрыто.
        </Typography>
      );
    } else if (state === null) {
      return <>...</>;
    } else {
      return (
        <Typography sx={{ fontSize: "15px", color: "gray" }}>
          Что то пошло не так {state}
        </Typography>
      );
    }
  }*/





  function closePeerConnect(){
      try{
        console.log('run ===> closePeerConnect')
        peer.disconnect();
        peer.destroy();
        localStream.current.MediaStream = null;
        setStreamRemote(null)
        setVideoChatPageState(videoChatState.CallEnd)
        sendMsgWs(wsObject.room_info[0].userId, 'call_end', []);
      }catch(e){
        console.error(e); 
      }
  }


  function closePeerConnect2(){
    try{
      console.log('run ===> closePeerConnect')
      peer.disconnect();
      peer.destroy();
      localStream.current.MediaStream = null;
      setStreamRemote(null)
      setVideoChatPageState(videoChatState.CallEnd)
      //sendMsgWs(wsObject.user_id, 'call_end', []);
    }catch(e){
      console.error(e); 
    }
}

  const classes = useStyles();

  const [screenHeight, setScreenHeight] = React.useState(window.innerHeight);
  const [videoSizeFirst, setVideoSizeFirst] = React.useState(window.innerHeight/2);
  const [videoSizeSecond, setVideoSizeSecond] = React.useState(window.innerHeight/2);

  //console.log('screenHeight_main', screenHeight);

  React.useEffect(() => {
    const handleResize = () => {
      const height = window.innerHeight; 
      const half = height /2; 
      setScreenHeight(window.innerHeight);
      setVideoSizeFirst(half);
      setVideoSizeSecond(half);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);


  //console.log('videoSizeFirst', videoSizeFirst)


/*
  function RenderStatus(){
      
      if(room_info.length<2){
          return <LoaderWithStatus text="Ожидаем участников"/>
      }else if(room_info.length>2){
        return <LoaderWithStatus text="Не правильно количество пользователей"/>
      }      
      else{
        return <>dff</>
      }
  }*/



  function PageBuilder(props){
      const {state} = props;

      if(state === UiStatesList.CheckCameraMic){
          return <CheckCameraWidget refv={localVideoref} onStateChange={(res)=>{if(res===true){setUiState(UiStatesList.CheckWs);}}}/>
      }
      else if(state === UiStatesList.CheckWs){
          return <><CheckSocetPage socetInfo={wsObject}   onStateChange={(res)=>{if(res===true){setUiState(UiStatesList.CheckPeer);}}} /> </>
      }
      else if(state === UiStatesList.CheckPeer){
        return <><CheckPeerPage peerInfo={peerObject}  onStateChange={(res)=>{if(res===true){setUiState(UiStatesList.ShowCameraFullScree);}}} /></>
      }
      else if(state === UiStatesList.ShowCameraFullScree){
        return <><VideoWaitConnectPage closePeerConnect={closePeerConnect} streamRemote={streamRemote} stream={stream} pageState = {videoChatPageState} socetInfo={wsObject} refv={localVideoref} remontrefv={remontVideoref}/></>
      }
      else if(state === UiStatesList.ShowVideoChat){
        return <>UI с видео чатам</>
      }else{
        return <>что то пошло не так</>
      }         
  }

///wsObject

  function saveStr(stream){
    console.log('saveStr', stream)
    localStream.current['MediaStream'] = stream;
  }

  function VideoWaitConnectPage1(props){
    //const {socetInfo} = props;
    return <div>
      <h2>VideoWaitConnectPage</h2>

        <br/>

      
      
    </div>
  }

 







  function MsgBuilder(props){

      const {msg} = props;

      if(['', null, undefined].includes(msg)){
          return <></>;
      }else{
        return <>
          <Box  className={classes.msgBar} >
              <Typography className={classes.msgBarText}>{msg}</Typography>
          </Box>
        </>
      }
  }  
  

  return (

    
    <Box maxWidth={'sm'} className={classes.container}>
            <MsgBuilder msg={msgOnTop}/>
            <PageBuilder state={uiState}/>
        
    </Box>

   
  );
}


 
/*  23062023 1811 версия
<div className={classes.videoContainer} >
          <video ref={localVideoref} autoPlay style={{objectFit: 'cover',  height: videoSizeFirst}} />
          
          <div className={classes.msg2}>          
             {local_video.enabled === false ? 
             <>
              <ErrorOutlineIcon sx={{color: 'red'}}/> 
              <br/><br/>
              { local_video.err_text}
             </> : <></>}
          </div>           
        </div>

        <Divider />


        
        <div className={classes.videoContainer} style={{height: videoSizeSecond}}>
            <video ref={remontVideoref} autoPlay  style={{objectFit: 'cover',  height: videoSizeSecond}} />
            
            <div className={classes.msg2}>
                {
                 <LoaderWithStatus text={msg}/>
                }
            </div>         
        </div>
        
        <Fab sx={{background: 'red'}} className={classes.fab}>
        <CallIcon  sx={{color: 'white'}}/>
      </Fab>

*/

const useStyles = makeStyles((theme) => ({

  container: {
    display: 'flex',
    flexDirection: 'column',
    background: '#f3f3f3',
    height: '100vh',
    width: '100%',
    padding: 0, 
    margin: 0, 
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center', 
    overflow: 'hidden',
    //color: 'red'
  },

  videoContainer: {
    background: '#f3f3f3',
    position: 'relative',    
    width: '100%',
    border: 'none',
    overflow: 'hidden',    
  },

  msg:{
    //display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center', 
    width: '100%',
    height: '100%',
    fontSize: '13px',
    lineHeight: '1.3em',
    color: 'black'
  }, 

  msg2:{
    position: 'absolute',
    top: '50%',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center', 
    width: '100%',
    //left: '50%',
    //transform: translate('-50%', '-50%'),
    textAlign: 'center',
    fontSize: '12px',
    lineHeight: '1.3em',
    color: 'black'
  },
  fab: {
    position: 'absolute !important',
    bottom: '20px',
    right: '20px',
    zIndex: 9999,
  },

  msgBar:{
    position: 'absolute',
    top: 0,
    background: 'white',     
    width: '100%',
    padding: 4
  },

  msgBarText:{
    fontSize: '10px !important',
    fontStyle: 'italic'
  }
 
}));


/*
{
        <div
          style={{
            display: "flex",
            height: "100vh",
            flexDirection: "column",
          }}
        >
          {
            /// первый блок видео
            <div
              style={{
                flexGrow: 1, // backgroundColor: '#e9e9e9',
                border: "1px solid #d9d9e3",
                //overflow: 'hidden',
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                color: "black",
                //objectFit: "cover",
              }}
            >
              {
                <video
                  ref={remontVideoref}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                  autoPlay
                />
              }
            </div>
          }

          {
            <div
              style={{
                flexGrow: 1, // backgroundColor: '#e9e9e9',
                border: "1px solid #d9d9e3",
                //overflow: 'hidden',
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                color: "black",
                //objectFit: "cover",
              }}
            >
              {local_video ? (
                <></>
              ) : (
                <Typography
                  align="center"
                  sx={{ fontSize: "12px", color: "gray", fontStyle: "italic" }}
                >
                  Включите локальное видео
                </Typography>
              )}

              <div
                style={{
                  display: local_video ? "block" : "none",
                  position: "relative",
                  width: "100%",
                  height: "100%",
                }}
              >
                <video
                  ref={localVideoref}
                  style={{
                    //maxWidth: '100%',
                    //maxHeight: '100%',
                    //objectFit: 'scale-down'
                    // position: 'absolute',
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                  autoPlay
                ></video>
              </div>
            </div>
          }

          <Paper elevation={3}>
            <BottomNavigation
            // showLabels
            >
              <BottomNavigationAction
                label="Recents"
                icon={<FlipCameraAndroidOutlinedIcon />}
              />
              <BottomNavigationAction
                onClick={enableLocalVideo}
                label="Favorites"
                icon={<VideocamOffOutlinedIcon />}
              />
              <BottomNavigationAction
                label="Archive"
                icon={<MicOffOutlinedIcon />}
              />
            </BottomNavigation>
          </Paper>
        </div>
      }

*/





/*/// инициализация ws прод
const socket = io('https://api.mediker.kz', {
  // autoConnect: false,
  reconnectionDelayMax: 10000,
  auth: {
    token: "123",
  },
  secure: true
 // transports: ['websocket']
});

/// инициализация подключения PEER JS -- PROD
const peer = new Peer({
  host: `/`,
  //port: 443,
  path: '/peerjs',  /// урл
  config: {
    //iceServers: freeice(),
    'iceServers': [
      //{ url: 'stun:stun.l.google.com:19302' },
      //{ url: 'turn:homeo@turn.bistri.com:80', credential: 'homeo' }, 
      { url: "stun:stun.l.google.com:19302"  },
      { url: "stun:stun1.l.google.com:19302"  },
      { url: "stun:stun2.l.google.com:19302"  },
      { url: "stun:stun3.l.google.com:19302"  },
      { url: "stun:stun4.l.google.com:19302" },
      { url: "stun:stun.ekiga.net" },
      { url: "stun:stun.stunprotocol.org:3478" },
      { url: "stun:stun.voipbuster.com" },
      { url: "stun:stun.voipstunt.com" },      
    ]
  },

  debug: 3
});*/